module.exports = __webpack_public_path__ + "img/3-6-IMG_3001.eb3d0d3c.png";